import Card from '@/components/Card';
import { Options } from '@/components/ui/CheckboxGroup';
import { ConditionalRender } from '@/components/ui/ConditionalRender';
import {
  CheckboxGroupRepairDocumentsProvided,
  REPAIR_DOCUMENTS_PROVIDED_TO_IC,
} from '@/features/v2/vehicle-damage/components/CheckboxGroupRepairDocumentsProvided';
import {
  InputDocumentType,
  PROVIDED_TO_IC_INVOICES_LIST,
  PROVIDED_TO_IC_OTHER_DOCUMENTS_LIST,
  PROVIDED_TO_IC_RECEIPTS_LIST,
} from '@/features/v2/vehicle-damage/components/InputDocumentType';

import { useLingui } from '@lingui/react';

export const SurveyOnePartThree = () => {
  const { i18n } = useLingui();

  return (
    <>
      <Card>
        <CheckboxGroupRepairDocumentsProvided />
        <ConditionalRender
          when={(val) =>
            val.repair_documents_provided_to_ic
              ?.map((item: Options) => item.value)
              ?.includes(REPAIR_DOCUMENTS_PROVIDED_TO_IC.INVOICES)
          }
        >
          <InputDocumentType
            name={PROVIDED_TO_IC_INVOICES_LIST}
            label={i18n.t('Czego dotyczyły faktury?')}
          />
        </ConditionalRender>
        <ConditionalRender
          when={(val) =>
            val.repair_documents_provided_to_ic
              ?.map((item: Options) => item.value)
              ?.includes(REPAIR_DOCUMENTS_PROVIDED_TO_IC.RECEIPTS)
          }
        >
          <InputDocumentType
            name={PROVIDED_TO_IC_RECEIPTS_LIST}
            label={i18n.t('Czego dotyczyły rachunki?')}
          />
        </ConditionalRender>
        <ConditionalRender
          when={(val) =>
            val.repair_documents_provided_to_ic
              ?.map((item: Options) => item.value)
              ?.includes(REPAIR_DOCUMENTS_PROVIDED_TO_IC.OTHER_DOCUMENTS)
          }
        >
          <InputDocumentType
            name={PROVIDED_TO_IC_OTHER_DOCUMENTS_LIST}
            label={i18n.t('Czego dotyczyły dokumenty?')}
          />
        </ConditionalRender>
      </Card>
    </>
  );
};
export default SurveyOnePartThree;
